import { api } from '@shared/config/axiosConfig';
import { buildEndpoint } from '@shared/utils/buildEndpoint';
import { mapPaginationResponse } from '@shared/utils/mapPaginationResponse';
import { quotationExecutionDetailsFromDto, quotationFromDto, quotationListItemFromDto, quotationToDto, updateQuotationToDto } from '../mappers/quotationsMapper';
import { filtersToDto } from '@/api/actions/quotation/dto/filtersDto';

const BASE_ENDPOINT = 'quotation';

const buildServiceEndpoint = ({ id, action } = {}) => {
  return buildEndpoint(BASE_ENDPOINT, { id, action });
}

export const getQuotation = async (id) => {
  const endpoint = buildServiceEndpoint({ id });
  const response = await api.get(endpoint);
  return quotationFromDto(response.data);
};

export const getQuotations = async (data = {}) => {
  const params = {
    search_text: data.searchText,
    state: data.state,
    page: data.page,
    page_size: data.pageSize,
    ...filtersToDto(data), // TODO: mover el mapeo de filtros a mappers de esta feature
  };

  const endpoint = buildServiceEndpoint();
  const response = await api.get(endpoint, { params });
  return mapPaginationResponse(response, quotationListItemFromDto);
};

export const createQuotation = async (data) => {
  const payload = quotationToDto(data);

  const endpoint = buildServiceEndpoint();
  const response = await api.post(endpoint, payload);
  return quotationFromDto(response.data);
};

export const updateQuotation = async (id, data) => {
  const payload = updateQuotationToDto(data);

  const endpoint = buildServiceEndpoint({ id });
  const response = await api.put(endpoint, payload);
  return quotationFromDto(response.data);
};

export const downloadQuotationLog = async (id, { quotationInsuranceCarrierId, fileFormat }) => {
  const params = {
    quotation_insurance_carrier_id: quotationInsuranceCarrierId,
    file_format: fileFormat, // Opcional: 'json' | 'txt'. Por defecto retorna un .json si no se proporciona
  };

  const endpoint = buildServiceEndpoint({ id, action: 'download-log' });
  const response = await api.get(endpoint, { params, responseType: 'blob' });
  return response;
};

export const downloadRpaTrace = async (id, { quotationInsuranceCarrierId }) => {
  const params = {
    quotation_insurance_carrier_id: quotationInsuranceCarrierId,
  };

  const endpoint = buildServiceEndpoint({ id, action: 'download-rpa-trace' });
  const response = await api.get(endpoint, { params, responseType: 'blob' });
  return response;
};

export const getQuotationExecutionDetails = async (id, quotationInsuranceCarrierId) => {
  const endpoint = buildServiceEndpoint({
    id,
    action: `quotation-insurance-carriers/${quotationInsuranceCarrierId}/execution-details`,
  });

  const response = await api.get(endpoint);
  return quotationExecutionDetailsFromDto(response.data);
};
